module.exports = __webpack_public_path__ + "img/Carina.ee111cda.png";